/**
 * EmptySlidePanel - Empty state for when no slide is selected
 *
 * Displays a helpful message prompting the user to select a slide
 * from the scripts list to see audio controls.
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { MousePointerClick } from 'lucide-react';

interface EmptySlidePanelProps {
  className?: string;
}

export const EmptySlidePanel: React.FC<EmptySlidePanelProps> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center h-full',
        'text-center px-8',
        className
      )}
    >
      <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-zinc-800 flex items-center justify-center mb-4">
        <MousePointerClick className="w-8 h-8 text-gray-400 dark:text-zinc-500" />
      </div>
      <h3 className="text-base font-medium text-gray-600 dark:text-zinc-400 mb-1">
        Select a slide to preview
      </h3>
      <p className="text-sm text-gray-400 dark:text-zinc-500 max-w-[240px]">
        Click on any script card to see audio controls and detailed preview
      </p>
    </div>
  );
};

export default EmptySlidePanel;
